export default function () {
	jQuery('.js-expandable-content--toggle').on('click', function () {
		jQuery(this).siblings('.js-expandable-content--wrapper').slideToggle(300);
		jQuery(this).toggleClass('expanded');

		if (!jQuery(this).hasClass('expanded')) {
			let element = jQuery(this);

			jQuery([document.documentElement, document.body]).animate(
				{
					scrollTop: jQuery(element).parent().offset().top - 124,
				},
				0
			);
		}

		jQuery(this).find('.js-expandable-content--more, .js-expandable-content--less').toggle(0);
	});
}
